import { Box, VBox } from "@ui/box/Box";
import { TitledValue } from "@ui/table/TitledValue";
import { Fragment } from "react";
import { HLine } from "../HLine";
import { registrationForm } from "./RegisterView";

export const RegisterStep4 = () => {
	const data: { name: string; value: string }[] = [];
	const registrationFormKeys = Object.keys(registrationForm) as Array<
		keyof typeof registrationForm
	>;
	for (const i of registrationFormKeys) {
		const section = registrationForm[i];
		if (!section) continue;
		const sectionKeys = Object.keys(section) as Array<keyof typeof section>;
		for (const j of sectionKeys) {
			const key = j as string;
			if (
				key.indexOf("password") !== -1 ||
				key.indexOf("verification") !== -1
			)
				continue;
			data.push({
				name: key,
				value: section[j],
			});
		}
	}

	return (
		<>
			<VBox gap="5px">
				{data.map((val: any, index: number) => {
					return (
						<Fragment key={index}>
							<Box
								key={index}
								sx={{
									borderBottom: "1px solid rgba(0,0,0,.1)",
									padding: "10px",
								}}>
								<TitledValue
									title={val.name}
									value={val.value}
								/>
							</Box>
							<HLine />
						</Fragment>
					);
				})}
			</VBox>
		</>
	);
};
